import React from 'react';

import { ContactFlowNodeProps } from '..';
import BaseNode from '../BaseNode';

export default function CheckExclusionNode(props: ContactFlowNodeProps) {
  return <BaseNode {...props} title='Check Exclusion' />;
}
